import React from "react";
import { useMap } from "react-leaflet";
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import "./custom-zoom-btns.scss";

export default function ControlZoomBtns() {
  const map = useMap();

  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  return (
    <div className="zoom-control">
      <button
        className="zoom-control__button zoom-control__button--in"
        onClick={handleZoomIn}
        aria-label="Zoom in"
      >
        <ZoomIn fontSize="medium" />
      </button>
      <button
        className="zoom-control__button zoom-control__button--out"
        onClick={handleZoomOut}
        aria-label="Zoom out"
      >
        <ZoomOut fontSize="medium" />
      </button>
    </div>
  );
}
